var elem = document.getElementById('engrave_message_wrapper');
if(elem){
  document.getElementById('add-engraving').onchange = function() {
    var messageField1 = document.getElementById('engrave-message-1'); 
    var messageField2 = document.getElementById('engrave-message-2');
    if(this.checked){
      elem.style.display = 'block';
      messageField1.required = true;
      messageField1.classList.add("required");
      messageField2.required = true;
      messageField2.classList.add("required");
    }
    else{
      elem.style.display = 'none';
      messageField1.required = false;
      messageField1.classList.remove("required");
      messageField2.required = false;
      messageField2.classList.remove("required");
    }
  };
}
function adjustEngraveProducts(){
  var engrave_product_id = '44832140034235';
  let updateData = {"id": "44832140034235", "quantity": 0};
  const request = new XMLHttpRequest();
  request.open('GET', window.Shopify.routes.root + 'cart.js', false);  // `false` makes the request synchronous
  request.send(null);
  if (request.status !== 200) {
    // handle an error here
    return
  }
  data = JSON.parse(request.responseText);
  var cartItems = data.items;
  //check if we have any products added to the cart with engraving on it
  var plate_products = {};
  var engrave_products = {};
  var engraveRelatedPlateCartKeys = [];
  for (var i=0; i<cartItems.length; i++) {
    //lets push all engrave products to an object
    if(cartItems[i].id == engrave_product_id){
      engrave_products[cartItems[i].key] = {'plateProduct':cartItems[i].properties['_product_key'] ,'product':cartItems[i].properties['Product'],'line1':cartItems[i].properties['Line 1'],'line2':cartItems[i].properties['Line 2'],'qty':cartItems[i].quantity};
      engraveRelatedPlateCartKeys.push(cartItems[i].properties['_product_key']);
    }
    //push all dog collars to an object
    if(cartItems[i].properties['_Add Engraving']!==undefined && cartItems[i].properties['_Add Engraving'].toLowerCase() === 'yes'){
      if(cartItems[i].properties['Engraving Line 1'].length>0 || cartItems[i].properties['Engraving Line 2'].length>0)
      plate_products[cartItems[i].key] = {'name':cartItems[i].title, 'line1':cartItems[i].properties['Engraving Line 1'], 'line2':cartItems[i].properties['Engraving Line 2'],'qty':cartItems[i].quantity };
    }
  }
  //check to see if we have a collar that it has a missing engraving product
  var engraveCartItemNotFound = false;
  for (var key in plate_products) {
    plate = plate_products[key]; // value
    plateCartKey = key;
    if(!engraveRelatedPlateCartKeys.includes(plateCartKey)){
      engraveCartItemNotFound = true;
    }
    else{
      for (var i in engrave_products) {
        engrave = engrave_products[i]; // value
        if(engrave.qty != plate.qty && engrave.plateProduct == key){
          engraveCartItemNotFound = true;
        }
      }
    }
  }
  var items = [];
  if((Object.keys(plate_products).length>0 && engraveCartItemNotFound) || (Object.keys(plate_products).length != Object.keys(engrave_products).length)){
    for (var key in plate_products) {
      plate = plate_products[key]; // value
      items.push({id:44832140034235,quantity:plate.qty,properties:{"Product":plate.name,"Engraving Line 1":plate.line1,'Engraving Line 2':plate.line2,'_product_key':key}});
    }
    //before we add all engrave products to the cart, lets remove what we had before
    if(Object.keys(engrave_products).length>0){
      fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(updateData)
        })
        .then(response => {
          addEngravingToCart(items);
        })
        .catch((error) => {
          console.error('Error:', error);
      });
    }
    else{
      addEngravingToCart(items);
    }
  }
  else if(Object.keys(plate_products).length==0 && Object.keys(engrave_products).length>0){
    fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updateData)
      })
      .catch((error) => {
        console.error('Error:', error);
    });
  }
}
function addEngravingToCart(items){
  if(items.length>0){
    let formData = {
     'items': items
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      //console.log(response.json());
      window.location.href = '/cart';
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}
(function(ns, fetch) {
    if (typeof fetch !== 'function') return;
      ns.fetch = function() {
        const response = fetch.apply(this, arguments);
        response.then(res => {
          let path = res.url.split('?')[0]
            if ([
                  `${window.location.origin}/cart/change`,
                  //`${window.location.origin}/cart/add`,
                  `${window.location.origin}/cart/update`,
                ].includes(path)) {
                res.clone().json().then((data) =>{
                  adjustEngraveProducts();
                });
            }
        });
      return response;
    }
}(window, window.fetch));
adjustEngraveProducts();